import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetOpenHouseDataQueryVariables = Types.Exact<{
  startDate: Types.Scalars['DateTime']['input'];
}>;


export type GetOpenHouseDataQuery = { __typename?: 'Query', club_worldFamilyClub_goGoLivePromotion?: { __typename?: 'Club_WorldFamilyClub_GoGoLivePromotionConnection', nodes?: Array<{ __typename?: 'Club_WorldFamilyClub_GoGoLivePromotion', id: string, capLevel?: string | null, createTime?: any | null, parentGuideUrl?: string | null, priceInformation?: string | null, region?: string | null, serviceType?: string | null, videoUrl?: string | null, yearMonth?: string | null, topicYearMonth?: any | null, reviewPosterFileName?: string | null }> | null } | null };


export const GetOpenHouseDataDocument = gql`
    query GetOpenHouseData($startDate: DateTime!) {
  club_worldFamilyClub_goGoLivePromotion(
    filter: {serviceType: {eq: "VEFB"}, topicYearMonth: {gte: $startDate}}
    order: {yearMonth: DESC, capLevel: ASC}
    first: 99
  ) {
    nodes {
      id
      capLevel
      createTime
      parentGuideUrl @wf_blobSignature(name: "VES_PDF_SIGNATURE")
      priceInformation
      region
      serviceType
      videoUrl
      yearMonth
      topicYearMonth
      reviewPosterFileName @wf_blobSignature(name: "GOGOLIVE_IMAGE_SIGNATURE")
      createTime
    }
  }
}
    `;

/**
 * __useGetOpenHouseDataQuery__
 *
 * To run a query within a React component, call `useGetOpenHouseDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpenHouseDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpenHouseDataQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetOpenHouseDataQuery(baseOptions: Apollo.QueryHookOptions<GetOpenHouseDataQuery, GetOpenHouseDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpenHouseDataQuery, GetOpenHouseDataQueryVariables>(GetOpenHouseDataDocument, options);
      }
export function useGetOpenHouseDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpenHouseDataQuery, GetOpenHouseDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpenHouseDataQuery, GetOpenHouseDataQueryVariables>(GetOpenHouseDataDocument, options);
        }
export type GetOpenHouseDataQueryHookResult = ReturnType<typeof useGetOpenHouseDataQuery>;
export type GetOpenHouseDataLazyQueryHookResult = ReturnType<typeof useGetOpenHouseDataLazyQuery>;
export type GetOpenHouseDataQueryResult = Apollo.QueryResult<GetOpenHouseDataQuery, GetOpenHouseDataQueryVariables>;